import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';

import { PermissionsService } from '@core/services/permissions.service';

const TOKEN_KEY = 'token-avalservi';

let isRefreshing = false;
const refreshTokenSubject = new BehaviorSubject<string | null>(null);

export const TokenInterceptorFn: HttpInterceptorFn = (req, next) => {
  const permissionService = inject(PermissionsService);

  if (req.url.includes('/auth')) {
    return next(req);
  }

  const accessToken = permissionService.getToken();
  if (accessToken) {
    req = addToken(req, accessToken);
  }

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        if (!isRefreshing) {
          isRefreshing = true;
          refreshTokenSubject.next(null);

          return permissionService.refreshToken().pipe(
            switchMap((tokens) => {
              isRefreshing = false;
              const token = tokens.token ?? '';
              permissionService.saveToken(token);
              permissionService.saveRefreshToken(token);
              refreshTokenSubject.next(token);
              return next(addToken(req, token));
            }),
            catchError((err) => {
              isRefreshing = false;
              permissionService.logout();
              return throwError(() => err);
            })
          );
        }

        return refreshTokenSubject.pipe(
          filter((token): token is string => token !== null),
          take(1),
          switchMap((token) => next(addToken(req, token)))
        );
      }

      return throwError(() => error);
    })
  );
};

function addToken(request: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
  return request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });
}
